import { createElement } from 'react';
import { useEffect, useState, useCallback, useMemo } from 'react';
import './index.scss';
import { Box, Button, Input } from '@alifd/next';
import { entityMetadataUtil } from 'oadp-common';
import OadpAttributeSettingTransfer from '../common/oadp-attribute-setting-transfer';
const OadpEntityButtonReadFast = function OadpEntityButtonReadFast({ children, entity, value, defaultValue, label, style, type, size, onClick, queryAttributeList, disabled, __designMode, ...otherProps }) {
    const [inputValue, setInputValue] = useState(defaultValue || '');
    const [attributeShowDataSource, setAttributeShowDataSource] = useState([]);
    const [attributeDataSource, setAttributeDataSource] = useState([]);
    useEffect(() => {
        const fetchAttributeData = async () => {
            try {
                console.log('OadpEntityButtonReadFast componentDidMount props', { entity });
                if (!entity) {
                    console.log('OadpEntityButtonReadFast componentDidMount entity is undefined');
                    return;
                }
                const attributeData = await entityMetadataUtil.asyncSelectAttributeListWithReferByEntityId(entity);
                console.log('OadpEntityButtonReadFast componentDidMount attributeData', attributeData);
                let textAttributeDataSource = [];
                attributeData.list.forEach((item) => {
                    if (item.attributeType?.code === 'TEXT' || item.attributeType?.code === 'MULTI_TEXT') {
                        textAttributeDataSource.push({
                            ...item,
                            label: item.name,
                            value: item.id
                        });
                    }
                });
                setAttributeDataSource(textAttributeDataSource);
            }
            catch (error) {
                console.error('OadpEntityButtonReadFast componentDidMount Failed to fetch field options:', error);
            }
        };
        fetchAttributeData();
        setAttributeShowDataSource(queryAttributeList);
    }, [entity, queryAttributeList]);
    const placeholder = useMemo(() => {
        try {
            const validData = attributeShowDataSource || [];
            const names = validData
                .map(id => attributeDataSource.find(a => a.id === id)?.name)
                .filter(Boolean);
            return names.length ? `请输入${names.join('/')}` : '请输入';
        }
        catch (e) {
            console.error('Placeholder generation error:', e);
            return '请输入';
        }
    }, [attributeShowDataSource, attributeDataSource]);
    const handleInputChange = (value, event, reason) => {
        setInputValue(value.toString());
    };
    const handleButtonClick = () => {
        if (__designMode === 'design') {
            console.log('OadpEntityButtonReadFast handleButtonClick __designMode === design');
            return;
        }
        if (onClick) {
            console.log('OadpEntityButtonReadFast click inputValue', inputValue);
            onClick(inputValue);
        }
    };
    const handleDialogOk = useCallback((localValues) => {
        setAttributeShowDataSource([...localValues]);
    }, []);
    return (createElement(Box, { direction: "row", justify: "center", align: 'center' },
        createElement(Input, Object.assign({ value: inputValue, type: "text", placeholder: placeholder, defaultValue: defaultValue, onChange: handleInputChange, disabled: disabled, size: size, hasClear: true, hoverShowClear: true, style: { width: 400 } }, otherProps)),
        createElement(Button, { type: type, size: size, disabled: disabled, onClick: handleButtonClick }, label),
        createElement(OadpAttributeSettingTransfer, { attributeDataSource: attributeDataSource, attributeShowDataSource: attributeShowDataSource, onConfirm: handleDialogOk, __designMode: __designMode })));
};
export default OadpEntityButtonReadFast;
